import React, { useEffect, useState, useRef } from "react";
import SEO from '../services/SEO';
import useAuth from '../hooks/useAuth';
import { useTranslation } from "react-i18next";
//import axios from 'axios';
import useAxiosPrivateCookie from "../hooks/useAxiosPrivateCookie";

// let baseURL = "";
// if(process.env.NODE_ENV === 'production'){
// 	baseURL = "https://www.tlsengenharia.com.br:53074/api";
// }else{
//   baseURL = "https://localhost:7027/api";  
// }

// const api = axios.create({
// 	baseURL: baseURL, // Substitua pela URL da sua API
// 	withCredentials: true, // Permite o envio de cookies com as requisições
// 	headers: {
// 		'Access-Control-Allow-Origin': '*',
// 		'Access-Control-Allow-Headers': 'X-Requested-With',
// 		'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8' ,
// 		//'Accept': "application/json",
// 		//'Access-Control-Allow-Credentials':true
// 	}
// });



const TLSTestes = () => {

	const axiosPrivateCookie = useAxiosPrivateCookie();

	const handleLogin = async () => {
		await login();
		//await fetchProtectedData();
	};

	const handleProc = async () => {
		//await login(name, password);
		await fetchProtectedData();
	};

	const handleProcTeste = async () => {
		//await login(name, password);
		await fetchProtectedDataTeste();
	};

	const handleLogout = async () => {
		//await login(name, password);
		//await fetchProtectedData();
		await fetchLogout();
	};

	window.scrollTo(0, 0);

	const { t, i18n: { changeLanguage, language } } = useTranslation();
	const { auth } = useAuth();

	const login = async () => {
		try {
			const response = await axiosPrivateCookie.post('/PageInfo', { "em": "thiagolemedasilva@hotmail.com", "sn": "$2a$12$vf5J1rN32sCdfVDEZw2xlusr8mfrG.U8CNjgSILzucz89I4V3nXZ6", ps : true });
			console.log('Login bem-sucedido:', response.data);
		} catch (error) {
			console.error('Erro ao fazer login:', error);
		}
	};
	
	const fetchProtectedData = async () => {
		try {
			const response = await axiosPrivateCookie.post('/UserSubscriptions', { "em": "thiagolemedasilva@hotmail.com"});
			console.log('Dados protegidos assinaturas do usuário:', response.data);
		} catch (error) {
			console.error('Erro ao acessar dados protegidos assinaturas do usuário:', error);
		}
	};
	
	const fetchProtectedDataTeste = async () => {
		try {
			const response = await axiosPrivateCookie.post('/AdminDashboard');
			console.log('Dados protegidos Teste Roles:', response.data);
		} catch (error) {
			console.error('Erro ao acessar dados protegidos Roles:', error);
		}
	};
	
	const fetchLogout = async () => {
		try {
			const response = await axiosPrivateCookie.post('/PageInfoLogout');
			console.log('Realizou logout:', response.data);
		} catch (error) {
			console.error('Erro ao realizar logout:', error);
		}
	};

	return (
		<div>
			<SEO title="TLS Engenharia" description="Descubra soluções inovadoras em software e tecnologia que impulsionam negócios e simplificam processos. Acesse e explore as últimas tendências tecnológicas!" />
			<h2 className="title is-1">{t('Testes')}</h2>
			<br />
			<hr />
			<br />
			<h1>Login</h1>
			<button onClick={handleLogin}>Login</button>
			<button onClick={handleProc}>Assinaturas do usuário</button>
			<button onClick={handleProcTeste}>Protect Testes</button>
			<button onClick={handleLogout}>Logout</button>
			
		</div>
	);
}


export default TLSTestes;